import { BrandMark } from '../../components/BrandMark.js';
import { ThemeToggle } from '../../components/ThemeToggle.js';

/** The PeopleOrbit mark shown atop the standalone public pages — legal, certificate verification,
 *  session handoff, live-training join. The sign-in/sign-up flow itself uses AuthLayout.tsx, which
 *  frames the same mark in a fuller split-screen layout.
 *
 *  Carries the theme toggle too: it's the one element every one of those pages already renders,
 *  so a signed-out visitor gets light/dark control without each screen adding it separately — and a fixed position keeps it in the same spot regardless of which screen is up. */
export function AuthBrand() {
  return (
    <>
      <div className="fixed right-4 top-4 sm:right-6 sm:top-6">
        <ThemeToggle />
      </div>
      <div className="flex items-center gap-2.5">
        <BrandMark size={30} className="shadow-accent" />
        <span className="font-display text-lg font-bold tracking-tight text-fg">
          People<span className="text-accent">Orbit</span>
        </span>
      </div>
    </>
  );
}
